export const toYesterdayOrToday = (maybeDate: Date | string | number): string | undefined => {
  const date = new Date(maybeDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  if (date >= today && date < tomorrow) {
    return "Today";
  } else if (date >= yesterday && date < today) {
    return "Yesterday";
  }
};
